import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';

class Component extends BaseComponent {
    componentDidMount() {
        this.vip = document.location.href.match(/vip/);

        this.props.links.map(link => {
            this.props.trackEvent([
                'Daily Nav',
                `${this.props.logged_in ? 'LI' : 'LO'} Impression`,
                link.label,
            ]);
        });
    }

    shouldComponentUpdate() {
        return false;
    }

    render({ links }) {
        if (links) {
            return (
                <vip-nav>
                    {links.map(this.renderLink)}
                </vip-nav>
            );
        }

        return (<vip-nav />);
    }

    renderLink = (link) => {
        let ahref = typeof link.href == 'object' ? `/vip${link.href.nonmobile}` : `/vip${link.href}`;

        return (
            <a href={ahref} onClick={() => this.trackClick(link.label)}>
                <row className='is-aligned-center'>
                    <column className='is-4 has-text-center'>
                        <img
                            src={link.img}
                            alt={link.label}
                        />
                    </column>
                    <column className='is-8' dangerouslySetInnerHTML={{__html: link.html}} />
                </row>
            </a>
        );
    }

    trackClick = (label) => {
        this.props.trackEvent([ 'Daily Nav', `${this.props.logged_in ? 'LI' : 'LO'} Click`, label ]);
    }
}

const mapStateToProps = (state) => ({
    logged_in: state.user && state.user.logged_in,
    links: state['daily-links'],
});

const mapDispatchToProps = (dispatch) => ({
    trackEvent: (payload) => dispatch({ type: 'ga:event', payload: payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);